import { render, staticRenderFns } from "./PerformanceEvaluation.vue?vue&type=template&id=40b4cadb&"
import script from "./PerformanceEvaluation.vue?vue&type=script&lang=js&"
export * from "./PerformanceEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b4cadb')) {
      api.createRecord('40b4cadb', component.options)
    } else {
      api.reload('40b4cadb', component.options)
    }
    module.hot.accept("./PerformanceEvaluation.vue?vue&type=template&id=40b4cadb&", function () {
      api.rerender('40b4cadb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/PerformanceEvaluation.vue"
export default component.exports